import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {GlobalConstantsComponent} from '../shared/global-constants/global-constants.component';

@Injectable({
  providedIn: 'root'
})
export class PartnerApiService {
  private apiUrl = GlobalConstantsComponent.apiURL;

  constructor(
    private http: HttpClient,
  ) { }

  getErasmusPlayReport(){
    return this.http.get(`${this.apiUrl}reports/erasmusPlay`) as any ;
  }

  getPartner(partnerKey){
    return this.http.post(`${this.apiUrl}getPartner`, {partnerKey});
  }

  public getPartnerFaq(id) {
    return this.http.get(`${this.apiUrl}getFaqByPartner/`+ id);
  }



    //--------- PAS UTILISE
  luko(user){
    const datas = {
      "firstname": user.firstname,
      "lastname": user.lastname,
      "email": user.email,
      "address": user.address,
      "phone_number": user.phone,
      "postcode": user.postalCode,
      "city": user.city,
      "country": "France",
      "residence_type": user.residenceType,
      "size": user.residenceSize,
      "room": user.rooms,
      "floor": user.floor,
      "main_home": true,
      "occupanttype": user.occupantType,
      // "policy_type": "switching",
      // "capital_amount": 1234,
      "partner_user_id": "4242ABCD",
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'partnership': 'kp_test_e347awu5mpan7x1e822olakzoxykm9bd'
    });
    const options = { headers: headers};
    return this.http.post(`https://cover-dev.luko.eu/v1/partner/pricing/mrh`, datas, options);
  }
  homebrella(user){
    const datas = {
      "building_type": "flat",
      "floor_type": "ground_floor",
      "occupant_type": "renter_non_furnished",
      "currently_living_in_house": false,
      "main_residence": true,
      "professional_use": false,
      "house_address_line_1": "32 Rue d'Antin",
      "city": "Lille",
      "postal_code": "59800",
      "surface_area": 32,
      "number_of_rooms_below_30": 1,
      "number_of_rooms_between_30_40": 0,
      "number_of_rooms_between_40_50": 0,
      "number_of_rooms_over_50": 0,
      "outbuilding_surface_area": 0,
      // "outbuilding_garage": false,
      "features_veranda_surface_area": 0,
      "features_fireplace": "no_fireplace",
      "sum_insured": 10000,
      "claims_made_in_last_3_years": 0,
      "previously_rejected": "never_rejected",
      "is_house_already_insured": false,
      "start_date_of_renting_house": "2021-04-13'",
      "moving_date": "2021-04-13'",
      "effective_date": "2021-04-13",

      "sex": "h",
      "date_of_birth": "1995-02-02",
      "marital_status": "single",
      "number_of_adults": 1,
      "number_of_children": 0,
      "profession": "student",
    };
    return this.http.post(`https://devis.homebrella-staging.com/api/webservice/les-furets/tariff/`, datas,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      });
  }
  homebrella2(user){
    const datas = {
      "quote_id": "38d1e5fe-eb9b-4d8f-8ba2-d1d2a79156a6",
      "first_name": "Jon",
      "last_name": "Snow",
      "contact_address_line_1": "23 Boulevard de Magenta",
      "contact_address_line_2": "something",
      "postal_code": "75001",
      "city": "Paris",
      "email_address": "jonsnow@gmail.com",
      "phone_number": "+33123456789",
      "product_type": "CLASSIC",
      "contact_type": "online_subscription"
    };
    return this.http.post(`https://devis.homebrella-staging.com/api/webservice/les-furets/contact/`, datas);
  }
  homebrella3(user){
    const datas = {
      "source": "LIVIN_FRANCE",
      "first_name": "Bernard",
      "last_name": "Longatte",
      "email_address": "myemail@hotmail.fr",
      "phone_number": "+33659295669",
      "occupant_type": "renter",
      "effective_date": "2021-04-14",
      "city": "Paris",
      "postcode": "74600",
      "house_number": "69",
      "full_address": "69 avenue des gresillons 74000 Asniere-sur-seine, Paris ",
      "surface_area": 64,
      "number_of_rooms": 3,
      "main_residence": true,
      "building_type": "house",
      "profession": "student",
      "date_of_birth": "1995-08-29",
      "sms_contact": true,
      "email_contact": true,
      "current_insurer": false,
      "locale": "en-gb"
    };
    return this.http.post(`https://devis.homebrella.fr/api/webservice/quote/`, datas);
  }

}
